const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

function markCustomerReviewsTitle() {
  const main = document.querySelector('#MainContent');
  if (!main) return false;

  const candidates = main.querySelectorAll('h1, h2, h3, h4, [role="heading"], div, span, p');
  for (const element of candidates) {
    if (normalizeText(element.textContent || '') !== 'customer reviews') continue;

    const childHasSameText = Array.from(element.children).some(
      (child) => normalizeText(child.textContent || '') === 'customer reviews'
    );
    if (childHasSameText) continue;

    element.classList.add('velora-reviews-title');
    return true;
  }

  return false;
}

function initializeCustomerReviewsTitle() {
  markCustomerReviewsTitle();

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      markCustomerReviewsTitle();
    });
  });

  const main = document.querySelector('#MainContent');
  if (main) observer.observe(main, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCustomerReviewsTitle, { once: true });
} else {
  initializeCustomerReviewsTitle();
}
